<template>
  <div id="select-anchor"></div>
  <div id="tooltip-anchor"></div>
  <div id="modal-anchor"></div>
  <div id="menu-anchor"></div>

  <div id="toast-anchor">
    <Toasts />
  </div>

  <MobileMenu v-if="isMobile" />
  <SidebarMenu v-if="!isMobile" />

  <main>
    <slot />
  </main>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount, ref } from 'vue';
import MobileMenu from '@/components/global/MobileMenu.vue';
import SidebarMenu from '@/components/global/SidebarMenu.vue';
import Toasts from '@/components/global/Toasts.vue';
import { useEcho, echoIsConfigured } from '@laravel/echo-vue';
import { useUserStore } from '@/stores/user';
const userStore = useUserStore();

[
  'users.all',
  userStore.userData?.id && `users.${userStore.userData.id}`,
  userStore.userData?.account_id && `accounts.${userStore.userData.account_id}`,
]
  .filter((channel): channel is string => Boolean(channel))
  .forEach((channel) => {
    if (!echoIsConfigured()) return;
    useEcho(channel, 'RequestUserData', userStore.requestUserDataRefresh, [], 'private');
  });

const isMobile = ref(false);

const checkMobile = () => {
  const el = document.body;

  if (window.innerWidth >= 1080) {
    el.classList.remove('mobile');
    isMobile.value = false;
  } else {
    el.classList.add('mobile');
    isMobile.value = true;
  }
};

onMounted(() => {
  checkMobile();
  window.addEventListener('resize', checkMobile);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkMobile);
});
</script>

<style lang="scss">
#select-anchor {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  z-index: 5000;
}

#menu-anchor {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  z-index: 5000;
}

#tooltip-anchor {
  height: 100%;
  left: 0;
  pointer-events: none;
  position: fixed;
  top: 0;
  z-index: 5000;
}

#toast-anchor {
  height: 100%;
  right: 20px;
  position: fixed;
  top: 20px;
  z-index: 10000;
}
</style>